import React from "react";
//* Material UI MUI
import { Box, Fade } from "@mui/material";

import {
  RHFCircleToggleGroupChildren,
  NotificationCard,
} from "@arp/react-ndbx";

export default function ToggleButtonChildrenNotification({ ...props }) {
  const {
    dataSetItem,
    fieldName,
    label = "",
    notificationCard = {},
    items = [],
    showNotification = false,
    showTooltip = false,
    tooltipText = "PLEASE ADD TOOLTIP TEXT!",
    children = null,
    fadeTimer = 500,
    errorVariant = false, //* used to change the variant to an error variant
  } = { ...props };

  return (
    <Box sx={{ outline: "0px solid red" }}>
      <RHFCircleToggleGroupChildren
        variant="circle-group"
        name={fieldName}
        defaultValue={dataSetItem}
        showTooltip={showTooltip}
        tooltipText={tooltipText}
        items={items}
        label={{ text: label }}
        children={children}
        error={errorVariant}
        sx={{ textAlign: "center" }}
      />
      <Box
        sx={{
          mt: 1,
          ml: "0px !important",
          display: showNotification === true ? "flex" : "none",
          justifyContent: "center",
        }}
      >
        <Fade in={showNotification === true} timeout={fadeTimer}>
          <Box>
            <NotificationCard
              cardType={notificationCard?.cardType}
              title={notificationCard?.title}
              message={notificationCard?.message}
              additionalText={notificationCard?.additionalText}
            />
          </Box>
        </Fade>
      </Box>
    </Box>
  );
}
